import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api/api.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GeneratePdfService } from 'src/app/services/pdf/generate-pdf.service';
import * as moment from 'moment';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;

  form: FormGroup;

  pageIndex = '0';
  pageSize = '10';
  sortBy = 'USD';
  sortDir = 'desc';
  loading: any = false;
  currencies: any = [];

  constructor(public apiService: ApiService, public tools: ToolsService, public pdfService: GeneratePdfService) { }

  ngAfterViewInit()  {}

  ngOnInit(): void {
    // this.loading = true;
    this.initForm();
  }

  public getClients(): any {
    console.log('cc ', this.form.get('client').value);
    if (this.form.get('client').value.length > 1) {
      this.apiService.getSumary(this.form.get('client').value).subscribe(response => {
        console.log(response);
        this.currencies = [];
        if (response?.code === 200) {
          const array: any = [];
          console.log(response['clients']);
          for (const item of response['clients']) {
            if (!this.currencies.find(elem => elem === item.iso)) {
              this.currencies.push(item.iso);
            }
            const include = array.find(elem => elem.id_number === item.id_number);
            if (!include) {
              array.push(this.buildInfo(response.clients, item.id_number));
            }
          }

          if (array.length > 0) {
            // const display = Object.keys(array[0]);
            this.displayedColumns = ['id_number', 'name', ...this.currencies];
          }
          this.dataSource.data = array;
          setTimeout(() => {
            this.resetIndexAndLoadData();
          }, 500);
        }
        this.loading = false;
      }, err => {
        this.loading = false;
        console.log('::::', err);
      })
    } else {
      this.dataSource.data = [];
    }
  }

  initForm() {
    this.form = new FormGroup({
      client: new FormControl(null, [Validators.required])
    });
  }

  generatePDF() {
    this.pdfService.autoTable(
      ['Cédula', 'Nombre', 'USD', 'COP', 'BS'],
      this.generateInfo(this.dataSource.data),
      'Resúmen de clientes',
      `Resúmen de clientes ${moment().format('YYYY-MM-DD Hms')}`,
      false,
      []
    );
  }

  generateInfo(data) {
    let array = [];
    for (let item of data) {
      let info = [
        item.id_number,
        item.name,
        this.tools.formatDisplay(item.USD, 3, 3, '.', ',', ''),
        this.tools.formatDisplay(item.COP, 3, 3, '.', ',', '$'),
        this.tools.formatDisplay(item.BS || 0, 3, 3, '.', ',', '$')
      ];
      array.push(info);
    }
    return array;
  }

  buildInfo(clients, id_number) {
    let obj = {};
    let name;
    let find = clients.filter(elem => elem.id_number === id_number);
    for (let item of find) {
      name = item.name;
      obj[item.iso] = item.monto;
    }

    obj['name'] = name;
    obj['id_number'] = id_number;
    return obj;
  }

  resetIndexAndLoadData() {
    if (this.sort) {
      this.dataSource.data = this.tools.orderList(this.dataSource.data, this.sort.active, this.sort.direction);
    }
  }

  loadData() {}

}
